
import { Button ,CircularProgress} from "@mui/material";
import * as React from "react";

type ButtonProps = {
  color?:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
  variant?: "text" | "outlined" | "contained";
  buttonName?: string;
  style?: object;
  classname?:string;
  buttonIcon?: any;
  disabled?:boolean;
  onClickHandle?: () => void;
  isBtnEnabled?:boolean;
  isLoading?: boolean; 
  startIcon?: any;
  link?: string;
  ariaLabel?: string;
};

export function ButtonComponent(props: ButtonProps) {
  const { buttonName, style, onClickHandle, color, variant ,classname, buttonIcon, isBtnEnabled,isLoading, link,ariaLabel} = props;
 
  const handleClick = () => {
    if (link) {
      // window.location.href = link;
      window.open(link, "_blank");
    } else if (onClickHandle) {
      onClickHandle();
    }
  };
  return (
    <Button
    data-testid={`ssarchive-${buttonName}-btn`}
    variant={variant}
    disableElevation
    onClick={handleClick}
    // onClick={onClickHandle}
    sx={style}
    color={color}
    className={classname}
    endIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : ''}
    disabled={isLoading || isBtnEnabled}
    startIcon={buttonIcon}
    aria-label={ariaLabel || buttonName}
    >
      {buttonName}
    </Button>
  );
}
